/**
 * The activity log's src:172 page descriptor. Kept beside the page (as `tasks-bi.ts` is) so the
 * page-load and every click report the same `page_name`/`page_version` pair.
 *
 * Distinct from `lib/bi-page-name.ts`, which maps the ROUTE to the shared cross-surface page name
 * (`activity_log`, matched by both phones). This one is the legacy web-only vocabulary.
 */
export const ACTIVITY_PAGE = {
  page_name: 'activity_page' as const,
  page_version: 'v1_activity_page' as const,
};
